/**
 * Hook that returns the workspace role and related data for the current user
 */
import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { WorkspaceMember } from '../../../api/workspaces/getWorkspaceMembers';
import { getWorkspaceRole } from '../../../api/workspaces/role/getWorkspaceRole';

interface UseGetWorkspaceRole<T = WorkspaceMember> {
  select?: (accountResponse: WorkspaceMember) => T;
  workspaceId: string;
}

export function useGetWorkspaceRole<T = WorkspaceMember>({
  workspaceId,
  select,
}: UseGetWorkspaceRole<T>) {
  return useQuery({
    queryKey: workspaceKeys.member(workspaceId),
    queryFn: () => getWorkspaceRole(workspaceId),
    select: select,
  });
}
